
import { Icon, Empty } from '@atom/atom-ui';
import '@atom/atom-ui/es_750_rem/icon/style';
import '@atom/atom-ui/es_750_rem/empty/style';
import '@atom/atom-icons/icons/transmit';
import '@atom/atom-icons/icons/arrow-right';
import { Component, Vue } from 'vue-property-decorator';
import { isTrueArray } from '@king-fisher/mobileweb-lib';

import { statClick } from '@/config/stat';
import { pushBy2804 } from '@/utils/tools';
import { shareReport } from '@/utils/share';

import SubscribeButton from '@/components/subscribe/SubscribeButton.vue';
import ExploreReportList, { getHotReports } from '@/components/common/ExploreReportList.vue';

@Component({
  components: {
    [Icon.name]: Icon,
    [Empty.name]: Empty,
    ExploreReportList,
    SubscribeButton,
  },
})
export default class ExploreReportCard extends Vue {
  isEmpty = false;
  groupList = null;

  jumpMore() {
    pushBy2804('/exploreReport', '');
    statClick('ths_mob_yanbao_pagetop_djgd');
  }

  created() {
    getHotReports()
      .then(list => {
        this.groupList = list;
      })
      .catch(() => {
        this.isEmpty = true;
      });
  }

  handleShareClick() {
    shareReport({
      dateStr: this.lastDateInfo.formatDate,
      list: this.topThreeReports,
    });
    this.$emit('shareReportClick');
  }

  get topThreeReports() {
    if (!isTrueArray(this.groupList)) {
      return null;
    }
    return this.groupList[0].items.slice(0, 3);
  }

  get lastDateInfo() {
    if (!isTrueArray(this.groupList)) {
      return '';
    }

    return this.groupList[0];
  }
}
